<template>
  <div>
	<!-- <div class="fixed-header w-full"> -->
	<TopAppBar
	  :leftBtnMode="leftBtnMode"
	  :rightBtnMode="rightBtnMode"
	  :title="title"
	  :leftBtnMethod="leftBtnMethod"
	  :rightBtnMethod="rightBtnMethod"
    :hideCategory="false"
	  staticMode="true"
	></TopAppBar>
			<div class="d-flex flex-column vh-100">
				<TopAppBarDrawer></TopAppBarDrawer>
				<RewardBadgeList></RewardBadgeList>
				<transition name="fade" mode="out-in">
					<router-view></router-view>
				</transition>
			</div>
  </div>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import RewardBadgeList from '@/components/reward/BadgeList'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

export default {
	name: 'Reward',

	data() {
		return {
			// title
			leftBtnMethod: () => { this.$router.go(-1)}
		}
	},
	components: {
		TopAppBar,
		RewardBadgeList,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin],

	watch: {
		'$route' (to, from) {
		}
	},

	mounted() {
		let	titleBrand = localStorage.getItem('brandName')
		this.setTopAppBarHomeSearch(titleBrand)
	}
}

</script>
